import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface TierCompleteOverlayProps {
  /** The lesson has shown its tier-complete screen. */
  shown: boolean;
  /** The tier is won and its wrap-up is on the way (phrasesTilNextTier is 0). */
  tierWon: boolean;
  /**
   * MUS-651: the lesson's "didn't load" message is up. The overlay sits above
   * it (z-index 1500 to its 11) and would leave its Retry and Back to roadmap
   * dimmed and out of reach, so it gives way while the message shows.
   */
  lessonDidNotLoadShown: boolean;
  height: string;
  children?: ReactNode;
}

/** The dimmed layer over the lesson while a won tier waits for its wrap-up. */
const TierCompleteOverlay = ({
  shown,
  tierWon,
  lessonDidNotLoadShown,
  height,
  children,
}: TierCompleteOverlayProps) => {
  if (!shown || lessonDidNotLoadShown) return null;
  return (
    <Box
      data-testid="tier-complete-overlay"
      sx={{
        height,
        width: '100%',
        visibility: tierWon ? 'unset' : 'hidden',
        backgroundColor: '#414753',
        opacity: '70%',
        position: 'absolute',
        zIndex: '1500',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  );
};

export default TierCompleteOverlay;
